import classnames from 'classnames';
import { bool, elementType, func, string } from 'prop-types';
import { Component } from 'react';

import Button from '../button/Button';

export default class SystemTitleActionButton extends Component {
  static propTypes = {
    enabled: bool,
    disabled: bool,
    onClick: func.isRequired,
    iconType: elementType.isRequired,
    label: string.isRequired,
    className: string,
  };

  render() {
    const {
      enabled = true,
      disabled = false,
      onClick,
      iconType: IconComponent,
      label,
      className,
    } = this.props;

    if (!enabled) {
      return null;
    }

    return (
      <Button
        disabled={disabled}
        className={classnames('action-button', className)}
        onClick={onClick}
      >
        <span className="action-button__inner">
          <span className="action-button__icon">
            <IconComponent className="icon-system-title-menu" />
          </span>
          <span className="action-button__text">{label}</span>
        </span>
      </Button>
    );
  }
}
